import { render, staticRenderFns } from "./huaWarn.vue?vue&type=template&id=68eac868&scoped=true&"
import script from "./huaWarn.vue?vue&type=script&lang=js&"
export * from "./huaWarn.vue?vue&type=script&lang=js&"
import style0 from "./huaWarn.vue?vue&type=style&index=0&id=68eac868&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68eac868",
  null
  
)

export default component.exports